import loginHero from "@/assets/images/login-hero.png";
import BrandLogo from "@/assets/logo/brand-logo.png";
import { auth } from "@/services/auth.service";
import { useAuthStore } from "@/stores/auth.store";
import type { LoginRequest } from "@/types/auth";
import { Button, Card, Form, Input, message } from "antd";
import { useLoading } from "@/hooks/use-loading";
import { useNavigate } from "react-router-dom";

export default function AuthPage() {
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const { loading, withLoading } = useLoading();

  const useMockLogin = import.meta.env.VITE_USE_MOCK_LOGIN === "true";

  const initialValues = useMockLogin
    ? {
        email: import.meta.env.VITE_MOCK_LOGIN_EMAIL,
        password: import.meta.env.VITE_MOCK_LOGIN_PASSWORD,
      }
    : undefined;

  const onFinish = async (values: LoginRequest) => {
    try {
      const res = await withLoading(() => auth(values));
      if (res.status) {
        useAuthStore.getState().login(res.data);
        navigate("/inventory", { replace: true });
      } else {
        message.error(res.message || "Login failed");
      }
    } catch (error) {
      console.error("Login failed:", error);

      message.error(error instanceof Error ? error.message : "Login failed");
    }
  };

  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden">
      <img
        src={loginHero}
        alt="Aerial view of tropical islands and turquoise sea"
        width={1024}
        height={1536}
        className="absolute inset-0 size-full object-cover"
      />
      <div className="absolute inset-0 bg-primary/10" aria-hidden="true" />

      <div className="px-4 py-6 max-w-xl mx-auto w-full">
        <Card style={{ borderRadius: "12px" }} className="shadow-2xl">
          <img
            src={BrandLogo}
            alt="Brand Logo"
            className="mx-auto my-4 w-52 md:w-56 h-auto"
          />

          <Form
            form={form}
            name="login"
            layout="vertical"
            autoComplete="off"
            onFinish={onFinish}
            initialValues={initialValues}
            requiredMark={(label, { required }) => (
              <>
                {label}
                {required && <span className="ml-1 text-destructive">*</span>}
              </>
            )}
          >
            <Form.Item
              label="USERNAME"
              name="email"
              rules={[{ required: true, message: "Please enter your email" }]}
            >
              <Input
                style={{ borderRadius: "12px" }}
                maxLength={50}
                placeholder="Enter Email"
              />
            </Form.Item>

            <Form.Item
              label="PASSWORD"
              name="password"
              rules={[
                { required: true, message: "Please enter your password" },
              ]}
              hasFeedback
            >
              <Input.Password
                style={{ borderRadius: "12px" }}
                placeholder="Enter Password"
              />
            </Form.Item>

            <Button
              type="default"
              variant="solid"
              htmlType="submit"
              style={{ borderRadius: "12px", width: "100%", marginTop: "16px" }}
              loading={loading}
              block
            >
              {loading ? "Logging in..." : "Login"}
            </Button>
          </Form>
        </Card>
      </div>
    </main>
  );
}
